import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/incidents/incidents/{-$id}')({
  beforeLoad: () =>
    getTitleContextSlice(window.location.pathname.toLowerCase().endsWith('/incidents/incidents') ? 'Incidents' : 'Incident Details'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
